export const api_base_url = "channels.trinka.ai"
export const trinka_server_URL_DEV = "dev.cloud.trinka.ai"
export const trinka_server_URL_UAT = "uat.cloud.trinka.ai"
export const trinka_server_URL_LIV = "cloud.trinka.ai"

export const environment = {
  production: true,
  // production: false,
  basePath: 'https://www.trinka.ai/jp',
  server_address: "https://"+api_base_url,
  //getCountryCode: "https://uat.payments-api.trinka.ai",
  getCountryCode: "https://payments-api.trinka.ai",
  server_url: {
    katana_server: "https://gc.crimsoni.ai/api/v1/service/katana",
    gc_server: "https://gc.crimsoni.ai",
    //phrasebank_server: "http://188.214.128.158:7776"
    phrasebank_server: "https://phrasebank.trinka.ai",
    //paraphraser_server: "https://paraphraser.trinka.ai",
    paraphraser_server: "https://paraphraser.trinka.ai",
    ai_detection_server: "https://api-content-detector.trinka.ai",
    //multilingual_server: "https://api-content-detector.trinka.ai"
    multilingual_server: "https://api-content-detector.trinka.ai"
  },
  // application_server_address : "http://" + trinka_server_URL_DEV,
  // application_server_address : "http://" + trinka_server_URL_UAT,
  application_server_address : "https://" + trinka_server_URL_LIV,
  amplitude_api_key: "d6d0919d33fe750608c491612d7bcd97",
  social_redirectURL: "cloud.trinka.ai/signin",
  // social_redirectURL: "localhost:4201/signin",
  trialMode : false,
  enago_social_redirect_url: "http://accounts.trinka.ai/External/Login?providerId="
};
